import { StringSchema } from 'yup';

const validate = (value: string): boolean => {
  if (!value || ![9, 10, 11].includes(value.length)) return false;

  const blackList = [
    '00000000000',
    '11111111111',
    '22222222222',
    '33333333333',
    '44444444444',
    '55555555555',
    '66666666666',
    '77777777777',
    '88888888888',
    '99999999999',
  ];

  const fixedValue = value.padStart(11, '0');

  if (blackList.includes(fixedValue)) return false;

  const length = 11;
  const digit = parseInt(fixedValue[length - 1], 10);
  let sum = 0;
  let mod = 0;
  let calculatedDigit = 0;

  const reverseNumbersWithoutDigit = fixedValue
    .substring(0, 10)
    .split('')
    .reverse()
    .map((i) => parseInt(i, 10));

  for (let i = 0; i < 8; i++) {
    const alg = reverseNumbersWithoutDigit[i];
    const multiplier = i + 2;
    sum += alg * multiplier;
  }

  sum += reverseNumbersWithoutDigit[8] * 2;
  sum += reverseNumbersWithoutDigit[9] * 3;
  mod = sum % length;

  calculatedDigit = length - mod;
  calculatedDigit = calculatedDigit >= 10 ? 0 : calculatedDigit;

  return calculatedDigit === digit;
};

export default function (this: StringSchema, message = 'Digite um renavam válido.') {
  return this.test('renavam', message, (value) => validate(value));
}
